  // Helper functions to manage modal visibility
  export function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  export function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }